import moment from 'moment';
import { pathServer } from '../app/shared/constants/Constants';

// ICONS
export const Icons = {
  dashboard: {
    url: `${pathServer.PATH_ICONS}icon_dashboard.svg`,
  },
  chat: {
    url: `${pathServer.PATH_ICONS}Chat.svg`,
  },
  notification: {
    url: `${pathServer.PATH_ICONS}icon_camp_notificacion.svg`,
  },
  poligono: {
    url: `${pathServer.PATH_ICONS}poligono.svg`,
  },
  construct: {
    url: `${pathServer.PATH_ICONS}icon_construct.svg`,
  },
  arrowLeft: {
    url: `${pathServer.PATH_ICONS}arrow_left.svg`,
  },
  people: {
    url: `${pathServer.PATH_ICONS}people.svg`,
  },
  company: {
    url: `${pathServer.PATH_ICONS}company.svg`,
  },
  companyWhite: {
    url: `${pathServer.PATH_ICONS}company-white.svg`,
  },
  calendar: {
    url: `${pathServer.PATH_ICONS}ic_calendar.svg`,
  },
  detail: {
    url: `${pathServer.PATH_ICONS}detail.svg`,
  },
  search: {
    url: `${pathServer.PATH_ICONS}ic_search_blue.svg`,
  },
  searchOrange: {
    url: `${pathServer.PATH_ICONS}ic_search.svg`,
  },
  time: {
    url: `${pathServer.PATH_ICONS}icon_time.svg`,
  },
  pdf: {
    url: `${pathServer.PATH_ICONS}icon_pdf.svg`,
  },
  download: {
    url: `${pathServer.PATH_ICONS}icon_download.svg`,
  },
  arrowBack: {
    url: `${pathServer.PATH_ICONS}icon_flecha_back.svg`,
  },

  arrowDown: {
    url: `${pathServer.PATH_ICONS}icon_fecha-down.svg`,
  },

  calendarOrange: {
    url: `${pathServer.PATH_ICONS}calendar_orange.svg`,
  },
  downloadGreen: {
    url: `${pathServer.PATH_ICONS}download_green.svg`,
  },

  unlock: {
    url: `${pathServer.PATH_ICONS}unlock.svg`,
  },

  block: {
    url: `${pathServer.PATH_ICONS}block.svg`,
  },

  delete: {
    url: `${pathServer.PATH_ICONS}delete.svg`,
  },
  accept: {
    url: `${pathServer.PATH_ICONS}icon_accept.svg`,
  },
  acceptChanged: {
    url: `${pathServer.PATH_ICONS}icon_accept2.svg`,
  },

  deny: {
    url: `${pathServer.PATH_ICONS}icon_deny.svg`,
  },

  facebook: {
    url: `${pathServer.PATH_ICONS}fb.svg`,
  },
  youtube: {
    url: `${pathServer.PATH_ICONS}yt.svg`,
  },
  userInfo : {
    url: `${pathServer.PATH_ICONS}icon_user_info.svg`,
  },
  profile : {
    url: `${pathServer.PATH_ICONS}profile.svg`,
  },

  arrowLeftBig: {
    url: `${pathServer.PATH_ICONS}arrow-left-big.svg`,
  },
  arrowRightBig: {
    url: `${pathServer.PATH_ICONS}arrow-right-big.svg`,
  },
  arrowLeftMedium: {
    url: `${pathServer.PATH_ICONS}arrow-left-medium.svg`,
  },
  arrowRightMedium: {
    url: `${pathServer.PATH_ICONS}arrow-right-medium.svg`,
  },

  upload: {
    url: `${pathServer.PATH_ICONS}icon_upload.svg`,
  },
  addCircle: {
    url: `${pathServer.PATH_ICONS}icon-add.svg`,
  },
  optionCard: {
    url: `${pathServer.PATH_ICONS}options-card.svg`,
  },
  success: {
    url: `${pathServer.PATH_ICONS}icon-success.svg`,
  },
  prdAccidentesP: {
    url: `${pathServer.PATH_ICONS}accidentes_personales.svg`,
  },

  prdDesgravamen: {
    url: `${pathServer.PATH_ICONS}desgravamen.svg`,
  },

  prdAhorroTotal: {
    url: `${pathServer.PATH_ICONS}ahorro_total.svg`,
  },
  prdRentaTotal: {
    url: `${pathServer.PATH_ICONS}renta_total.svg`,
  },
  prdRentasVitalicias: {
    url: `${pathServer.PATH_ICONS}rentas_vitalicias.svg`,
  },
  prdSCTR: {
    url: `${pathServer.PATH_ICONS}SCTR.svg`,
  },
  prdSoat: {
    url: `${pathServer.PATH_ICONS}soat.svg`,
  },
  prdVidaGrupo: {
    url: `${pathServer.PATH_ICONS}vida_grupo.svg`,
  },
  prdVidaLey: {
    url: `${pathServer.PATH_ICONS}vida_ley.svg`,
  },
  show: {
    url: `${pathServer.PATH_ICONS}show.svg`,
  },
  heartFavorite: {
    url: `${pathServer.PATH_ICONS}icon_heart_favorite.svg`,
  },
  heart:{
    url: `${pathServer.PATH_ICONS}icon_heart.svg`,
  },
  dragDrop: {
    url: `${pathServer.PATH_ICONS}move.svg`,
  },
  arrowOrange : {
    url: `${pathServer.PATH_ICONS}arrow-orange.svg`,
  },
  mail: {
    url: `${pathServer.PATH_ICONS}icon_mail.svg`,
  },
  userCreate : {
    url: `${pathServer.PATH_ICONS}user_create.svg`,
  },
  default : {
  url: `${pathServer.PATH_ICONS}arrow-right-medium.svg`,
  },
  printFile: {
    url: `${pathServer.PATH_ICONS}ic-print.svg`,
  },
  downloadFile: {
    url: `${pathServer.PATH_ICONS}ic-download.svg`,
  },
  refresh:{
    url: `${pathServer.PATH_ICONS}refresh.svg`,
  },
  smallCalendar: {
    url: `${pathServer.PATH_ICONS}small_calendar.svg`,
  },
  options2:{
    url: `${pathServer.PATH_ICONS}ic_options.svg`,
  },
  check : {
    url: `${pathServer.PATH_ICONS}icon-check.svg`,
  },
  download : {
    url: `${pathServer.PATH_ICONS}icon-download.svg`,
  },

  copy : {
    url: `${pathServer.PATH_ICONS}icon-copy.svg`,
  },
  trash : {
    url: `${pathServer.PATH_ICONS}icon-trash.svg`,
  },
  upload2: {
    url: `${pathServer.PATH_ICONS}icon_upload2.svg`,
  },

  laptop: {
    url: `${pathServer.PATH_ICONS}icon_laptop.svg`,
  },
  orgTransfor:  {
    url: `${pathServer.PATH_ICONS}org-transfor.svg`,
  },
  orgAlvamedic:  {
    url: `${pathServer.PATH_ICONS}org-alvamedic.svg`,
  },
  orgAnkost:  {
    url: `${pathServer.PATH_IMG}ankost_logo.svg`,
  },
};

//NEWSLETTER
const DATE_EXPIRATION_UNIX_DEFAULT = moment().add('d', 7).format('X');
const DATE_NOW_UNIX_DEFAULT = moment().format('X');

export const MAGAZINE_BOLETIN_VIVE_SALUD = '00000003';
export const MAGAZINE_BOLETIN_FINANCIERO = '00000004';
export const MAGAZINE_BOLETIN_EN_VIVO = '00000001';
export const MAGAZINE_BOLETIN_QUEDATE_CASA = '00000002';

export const BASE_URL_PATH_FILE_NEWSLETTER = '/newsletter/get/';
export const MAX_SIZE_UPLOAD_FILE = 10485760;
export const MAX_SIZE_UPLOAD_IMG = 209715;
export const STORAGE_TOKEN_COGNITO = 'idTokenCognito';

export const BOLETIN_OBJ = {
  idTipoContenido: '',
  principalTitle: '',
  shortDescription: '',
  dateRegister: DATE_NOW_UNIX_DEFAULT,
  dateExpiration: DATE_EXPIRATION_UNIX_DEFAULT,
  valueRanking: 5,
  paragraphs: [
    {paragraph : '',},
    {paragraph : '',}
  ],
  newsletterKeywords: "test",
  content: [
    {
      title: '',
      description: '',
    },
  ],
  buttons: [
    {
      title: 'Click aquí',
      link: '',
    }
  ],
  s3UrlPdf: '',
  s3UrlImage: '',
};

export const isSoat = code => code === '66';

export const SUCESS_CODE_API = 200;

export const TYPE_DOCUMENT_DNI = 'l';
export const TYPE_DOCUMENT_CARNE = 'e';

export const NEWS_CATEGORIES = [
  {
    id: 1,
    name: 'Categoría 1'
  },
  {
    id: 2,
    name: 'Categoría 2'
  },
  {
    id: 3,
    name: 'Categoría 3'
  },
];

export const HEADER_CONTACTS = [
	{ elementProp: 'idOrganization', headerColumn: 'Organización'},
	{ elementProp: 'name', headerColumn: 'Nombre'},
	{ elementProp: 'company', headerColumn: 'Compañia'},
	{ elementProp: 'email', headerColumn: 'Correo'},
	{ elementProp: 'phone', headerColumn: 'Telefono'},
	{ elementProp: 'message', headerColumn: 'Mensaje'},
	{ elementProp: 'viewed', headerColumn: 'Visitado'},
	{ elementProp: 'idUserCreated', headerColumn: 'Usuario'},
]